import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-list-cities',
    templateUrl: './list-cities.component.html',
    styleUrls: ['./list-cities.component.scss']
})
export class ListCitiesComponent {

    @Input() cities: any = [];
    constructor() { }
}
